import { compose, withProps } from 'recompose';
import { withLabel } from '@/se/components/Label';
import TextInput from '@/se/components/inputs/TextInput';

export default compose(
  withLabel('Name'),
  withProps({ placeholder: 'e.g., Mark Nordstrom', required: true })
)(TextInput);
